import { render } from "./index.vue?vue&type=template&id=b9b92300"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SafeInput/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9b92300"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9b92300', __exports__)) {
    api.reload('b9b92300', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b9b92300", () => {
    api.rerender('b9b92300', render)
  })

}


export default __exports__